export default function initFSelect() {
  const openClass = 'opened';

  document.querySelectorAll('.fake-select').forEach((select) => {
    const opener = select.querySelector('.opener');

    if (opener) {
      opener.addEventListener('click', (e) => {
        e.preventDefault();

        document.querySelectorAll('.fake-select').forEach((el) => {
          if (el !== select) {
            el.classList.remove(openClass);
          }
        });

        select.classList.toggle(openClass);
      });
    }
  });

  document.addEventListener('click', (e) => {
    document.querySelectorAll('.fake-select').forEach((select) => {
      if (!select.contains(e.target)) {
        select.classList.remove(openClass);
      }
    });
  });
}
